<template>
  <div>
    <!-- 商户签名信息管理 -->
    <a-card title="商户签名信息管理" style="margin: 20px">
      <!-- 筛选区域 -->
      <div class="selectBox">
        <div class="item">
          <span>选择商户</span>
          <a-select
              v-model="selectedMerchantNo"
              placeholder="请选择商户"
              style="width: 200px"
              @change="handleMerchantChange"
              allow-clear
          >
            <a-select-option
                v-for="merchant in mainMerchantList"
                :key="merchant.merchantNo"
                :value="merchant.merchantNo"
            >
              {{ merchant.merchantNo }} - {{ merchant.merchantName || merchant.mchName }}
            </a-select-option>
          </a-select>
        </div>

        <div class="item">
          <span>通联商户号</span>
          <a-input v-model.trim="paramsData.cusid" placeholder="请输入通联商户号" allow-clear/>
        </div>
        <div class="item">
          <span>签名类型</span>
          <a-select v-model.trim="paramsData.signtype" placeholder="请选择签名类型" allow-clear>
            <a-select-option v-for="(type, value) in  commonDict.stl_acc_signType" :key="value" :value="value">
              <a-tag v-if="type.show" :color="type.color">{{ type.label }}</a-tag>
            </a-select-option>
          </a-select>
        </div>


        <div class="item">
          <a-button type="primary" @click="handleQuery">查询</a-button>
          <a-button style="margin-left: 8px" @click="handleReset">重置</a-button>
        </div>
      </div>

      <!-- 表格部分 -->
      <div class="tableBox">
        <div class="handleBtn">
          <a-button type="primary" @click="signInfoAddBtn" :disabled="!selectedMerchantNo">新增签名信息</a-button>
          <a-button type="primary" @click="handleQuery">刷新</a-button>
          <a-button type="primary" @click="handleExport">导出</a-button>
        </div>
        <div class="tableBody">
          <a-table
              :columns="columns"
              :data-source="tableData"
              :pagination="false"
              :row-key="record => record.id"
              :scroll="{ x: 1300 }"
          >


            <template slot="action" slot-scope="text, record">
              <a-button-group size="small">
                <a-button
                    icon="eye"
                    style="color: #1890ff;"
                    type="link"
                    @click="viewBtn(record)"
                >
                  查看
                </a-button>
                <a-button
                    icon="edit"
                    style="color: #52c41a;"
                    type="link"
                    @click="editBtn(record)"
                >
                  编辑
                </a-button>
                <a-button
                    icon="delete"
                    style="color: #ff4d4f;"
                    type="link"
                    @click="deleteBtn(record)"
                >
                  删除
                </a-button>
              </a-button-group>
            </template>
          </a-table>
        </div>
      </div>

      <!-- 分页部分 -->
      <div class="pagination-wrapper">
        <LcfsPagination :page-no.sync="pagination.pageNo" :page-size.sync="pagination.pageSize" :total="pagination.total"
                        :fn="getTableData"/>
      </div>
    </a-card>

    <!-- 新增/编辑签名信息弹窗 -->
    <a-modal
        v-model="signFormVisible"
        :title="formType === 'add' ? '新增签名信息' : '编辑签名信息'"
        @ok="handleSaveSignInfo"
        @cancel="handleCancelForm"
        :confirm-loading="confirmLoading"
        width="600px"
        :destroyOnClose="true"
    >
      <a-form-model
          ref="signForm"
          :model="formData"
          :rules="formRules"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
          :colon="false"
          label-align="left"
      >
        <a-form-model-item label="商户编号" prop="merchantNo">
          <a-select
              v-model="formData.merchantNo"
              placeholder="请选择商户"
              style="width: 200px"
              @change="onHandleMerchantChange"
              allow-clear
          >
            <a-select-option
                v-for="merchant in mainMerchantList"
                :key="merchant.merchantNo"
                :value="merchant.merchantNo"
            >
              {{ merchant.merchantNo }} - {{ merchant.merchantName || merchant.mchName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>


        <a-form-model-item label="通联商户号" prop="cusid">
          <a-input
              v-model.trim="formData.cusid"
              placeholder="请输入通联商户号"
              :disabled="formType === 'edit'"
              allow-clear
          />
        </a-form-model-item>

        <a-form-model-item label="签名类型" prop="signtype">
          <a-select
              v-model="formData.signtype"
              placeholder="请选择签名类型"
          >
            <a-select-option v-for="(type, value) in  commonDict.stl_acc_signType" :key="value" :value="value">
              <a-tag v-if="type.show" :color="type.color">{{ type.label }}</a-tag>
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="私钥" prop="prikey">
          <a-textarea
              v-model.trim="formData.prikey"
              placeholder="请输入私钥"
              :rows="3"
              allow-clear
          />
        </a-form-model-item>

        <a-form-model-item label="公钥" prop="pubkey">
          <a-textarea
              v-model.trim="formData.pubkey"
              placeholder="请输入公钥"
              :rows="3"
              allow-clear
          />
        </a-form-model-item>

        <a-form-model-item label="应用密钥" prop="appkey">
          <a-input
              v-model.trim="formData.appkey"
              placeholder="请输入应用密钥"
              allow-clear
          />
        </a-form-model-item>

      </a-form-model>
    </a-modal>

    <!-- 查看签名信息详情弹窗 -->
    <a-modal
        v-model="viewModalVisible"
        title="签名信息详情"
        @cancel="viewModalVisible = false"
        width="900px"
        :footer="null"
        :destroyOnClose="true"
    >
      <div v-if="viewData" class="sign-detail">
        <!-- 基本信息区域 -->
        <a-card title="基本信息" size="small" :bordered="false" class="detail-section">
          <a-descriptions bordered :column="2" size="small">
            <a-descriptions-item label="商户编号">
              <span class="detail-value">{{ viewData.merchantNo }}</span>
            </a-descriptions-item>
            <a-descriptions-item label="商户名称">
              <span class="detail-value">{{ viewData.merchantName }}</span>
            </a-descriptions-item>
            <a-descriptions-item label="渠道编号">
              <span class="detail-value">{{ viewData.channelNo }}</span>
            </a-descriptions-item>

            <a-descriptions-item label="应用编号">
              <span class="detail-value">{{ viewData.appNo || '-' }}</span>
            </a-descriptions-item>
            <a-descriptions-item label="通联商户号">
              <span class="detail-value">{{ viewData.cusid }}</span>
            </a-descriptions-item>


          </a-descriptions>
        </a-card>

        <!-- 密钥信息区域 -->
        <a-card title="密钥信息" size="small" :bordered="false" class="detail-section">
          <a-descriptions bordered :column="1" size="small">

            <a-descriptions-item label="签名类型">
              <a-tag :color="stl_acc_signType(viewData.signtype).color">{{ stl_acc_signType(viewData.signtype).label }}</a-tag>
            </a-descriptions-item>

            <a-descriptions-item label="私钥">
              <span class="detail-value">{{ viewData.prikey || '-' }}</span>

            </a-descriptions-item>
            <a-descriptions-item label="公钥">
              <span class="detail-value">{{ viewData.pubkey || '-' }}</span>

            </a-descriptions-item>
            <a-descriptions-item label="应用密钥">
              <span class="detail-value">{{ viewData.appkey || '-' }}</span>

            </a-descriptions-item>
          </a-descriptions>
        </a-card>


      </div>

      <!-- 空状态 -->
      <div v-else class="empty-state">
        <a-empty description="暂无签名信息数据"/>
      </div>
    </a-modal>
  </div>
</template>

<script>
import {message} from "ant-design-vue";

import LcfsPagination from "@/view/components/LcfsPagination.vue";
import {commonDict} from "@/utils/bizDict/commonDict";

export default {
  name: 'MchSignInfo',
  computed: {
    commonDict() {
      return commonDict
    }
  },
  components: {LcfsPagination},

  data() {
    return {
      // 主商户列表
      mainMerchantList: [],
      selectedMerchantNo: null,

      // 分页相关
      pagination: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      },

      // 表单相关
      signFormVisible: false,
      formType: 'add',
      confirmLoading: false,
      formData: {
        merchantNo: "",
        cusid: "",
        signtype: "RSA",
        prikey: "",
        pubkey: "",
        appkey: "",
      },
      formRules: {
        merchantNo: [
          {required: true, message: '请输入商户编号', trigger: 'blur'},
          {max: 32, message: '商户编号最长32个字符', trigger: 'blur'}
        ],
        cusid: [
          {required: true, message: '请输入通联商户号', trigger: 'blur'},
          {max: 32, message: '通联商户号最长32个字符', trigger: 'blur'}
        ],
        signtype: [
          {required: true, message: '请选择签名类型', trigger: 'change'}
        ],
        prikey: [
          {required: true, message: '请输入私钥', trigger: 'blur'},
          {max: 500, message: '私钥最长500个字符', trigger: 'blur'}
        ],
        pubkey: [
          {required: true, message: '请输入公钥', trigger: 'blur'},
          {max: 500, message: '公钥最长500个字符', trigger: 'blur'}
        ],
      },

      // 查看详情
      viewModalVisible: false,
      viewData: null,

      // 表格数据
      tableData: [],
      columns: [
        {
          title: "No",
          customRender: (text, record, index) => {
            return `${(this.pagination.pageNo - 1) * this.pagination.pageSize + (index + 1)}`;
          },
          align: "center",
          width: 60
        },
        {
          title: "商户编号",
          dataIndex: "merchantNo",
          align: "center",
          width: 120,
          ellipsis: true
        },
        {
          title: "通联商户号",
          dataIndex: "cusid",
          align: "center",
          width: 120,
          ellipsis: true
        },
        {
          title: "签名类型",
          dataIndex: "signtype",
          align: "center",
          width: 80,
          customRender: (text) => {
            const colors = {
              'RSA': 'green',
              'SM2': 'blue',
              'MD5': 'orange'
            };
            return (
                <a-tag color={colors[text] || 'default'}>
                  {text}
                </a-tag>
            );
          }
        },
        {
          title: "私钥(脱敏)",
          dataIndex: "prikey",
          align: "center",
          width: 150,
          ellipsis: true
        },
        {
          title: "应用密钥(脱敏)",
          dataIndex: "appkey",
          align: "center",
          width: 150,
          ellipsis: true
        },
        {
          title: "创建时间",
          dataIndex: "createTime",
          align: "center",
          width: 120,
          customRender: (text) => {
            if (!text) return "-";
            return this.formatDateTime(text);
          }
        },
        {
          title: "操作",
          key: "action",
          fixed: 'right',
          width: 180,
          align: "center",
          scopedSlots: {customRender: 'action'}
        }
      ],

      // 查询条件
      paramsData: {
        merchantNo: "",
        cusid: "",
        signtype: "",
      }
    };
  },
  mounted() {
    // 加载主商户列表
    this.loadMainMerchantList();
    this.getTableData();
  },
  watch: {
    // 监听选中商户变化，自动更新查询条件
    selectedMerchantNo(newVal) {
      if (newVal) {
        this.paramsData.merchantNo = newVal;
      } else {
        this.paramsData.merchantNo = '';
      }
    }
  },
  methods: {

    // 状态配置
    stl_acc_signType(status) {
      return commonDict.stl_acc_signType[status] || commonDict.stl_acc_signType.default;
    },


    async onHandleMerchantChange(value) {
      this.formData.merchantNo = value;


    },
    // 获取主商户列表
    async loadMainMerchantList() {
      try {
        // 假设您的API是 settleMerchantListApi，参数为 { merchantRelations: '1' }
        const res = await this.api.settleMerchantListApi({
          merchantRelations: '1'
        });
        if (res.code === 200) {
          this.mainMerchantList = res.data || [];

          // 初始化筛选参数 - 选择第一个商户
          if (this.mainMerchantList.length === 0) {
            message.warning('暂无商户数据');
          }
        } else {
          message.warning(res.info || '获取商户列表失败');
        }
      } catch (error) {
        console.error('获取商户列表失败:', error);
        message.error('获取商户列表失败');
      }
    },

    // 商户选择变化
    handleMerchantChange(value) {
      this.selectedMerchantNo = value;
      this.paramsData.merchantNo = value;

      // 重置页码
      this.pagination.pageNo = 1;

      // 如果选择了商户，自动查询
      if (value) {
        this.getTableData();
      } else {
        // 清空表格数据
        this.tableData = [];
        this.pagination.total = 0;
      }
    },

    // 格式化日期时间
    formatDateTime(dateTime) {
      if (!dateTime) return '-';
      try {
        const date = new Date(dateTime);
        return date.toLocaleString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        });
      } catch (e) {
        return dateTime;
      }
    },

    // 获取表格数据
    async getTableData() {

      const params = {
        pageNo: this.pagination.pageNo,
        pageSize: this.pagination.pageSize,
        ...this.paramsData
      };

      // 清除空参数
      Object.keys(params).forEach(key => {
        if (params[key] === '' || params[key] === null || params[key] === undefined) {
          delete params[key];
        }
      });

      const res = await this.api.pageMerchantSignInfoApi(params);
      if (res.code === 200) {
        this.tableData = res.data.records;
        this.pagination.total = res.data.total || 0;
      }
      if (res.code !== 200) {
        message.error(res.info);
      }


    },

    // 查询
    handleQuery() {
      this.pagination.pageNo = 1;
      this.getTableData();
    },

    // 重置
    handleReset() {
      this.selectedMerchantNo = null;
      this.paramsData = {
        merchantNo: "",
        cusid: "",
        signtype: "",
      };
      this.pagination.pageNo = 1;

      // 清空表格数据
      this.tableData = [];
      this.pagination.total = 0;
    },

    // 新增签名信息
    signInfoAddBtn() {
      if (!this.selectedMerchantNo) {
        message.warning('请先选择商户');
        return;
      }

      this.formType = 'add';
      this.signFormVisible = true;
      this.$nextTick(() => {
        this.resetForm();

        // 自动填充选中的商户编号
        if (this.selectedMerchantNo) {
          this.formData.merchantNo = this.selectedMerchantNo;

          // 尝试从主商户列表中获取其他信息
          const selectedMerchant = this.mainMerchantList.find(
              m => m.merchantNo === this.selectedMerchantNo
          );


        }
      });
    },

    // 编辑签名信息
    async editBtn(record) {
      try {
        // 根据商户编号获取详细信息
        const res = await this.api.getMerchantSignInfoApi(record.merchantNo);
        if ((res.code === 200 || res.success) && res.data) {
          this.formType = 'edit';
          this.formData = {...res.data};
          this.signFormVisible = true;
        } else {
          message.warning(res.message || res.info || "获取签名信息失败");
        }
      } catch (error) {
        console.error("获取签名信息失败:", error);
        message.error("获取签名信息失败");
      }
    },

    // 查看详情
    async viewBtn(record) {
      try {
        const res = await this.api.getMerchantSignInfoApi(record.merchantNo);
        if ((res.code === 200 || res.success) && res.data) {
          this.viewData = res.data;
          this.viewModalVisible = true;
        } else {
          message.warning(res.message || res.info || "获取签名信息详情失败");
        }
      } catch (error) {
        console.error("获取签名信息详情失败:", error);
        message.error("获取签名信息详情失败");
      }
    },

    // 重置表单
    resetForm() {
      this.formData = {
        merchantNo: "",
        cusid: "",
        signtype: "RSA",
        prikey: "",
        pubkey: "",
        appkey: "",
      };
      this.$refs.signForm && this.$refs.signForm.resetFields();
    },

    // 保存签名信息
    async handleSaveSignInfo() {
      this.$refs.signForm.validate(async (valid) => {
        if (valid) {
          this.confirmLoading = true;
          try {
            let res;

            if (this.formType === 'add') {
              res = await this.api.addMerchantSignInfoApi(this.formData);
            } else {
              res = await this.api.updateMerchantSignInfoApi(this.formData);
            }

            if (res.code === 200 || res.success) {
              message.success(this.formType === 'add' ? '新增成功' : '编辑成功');
              this.signFormVisible = false;
              this.getTableData();
            } else {
              message.error(res.message || res.info || (this.formType === 'add' ? '新增失败' : '编辑失败'));
            }
          } catch (error) {
            console.error("保存失败:", error);
            message.error(this.formType === 'add' ? '新增失败' : '编辑失败');
          } finally {
            this.confirmLoading = false;
          }
        } else {
          message.error('请填写完整信息');
        }
      });
    },

    // 取消表单
    handleCancelForm() {
      this.signFormVisible = false;
      this.resetForm();
    },

    // 删除签名信息
    deleteBtn(record) {
      this.$confirm({
        title: `确认删除商户 [${record.merchantNo}] 的签名信息吗？`,
        content: '删除后无法恢复，请谨慎操作。',
        okText: '确认删除',
        cancelText: '取消',
        okType: 'danger',
        onOk: async () => {
          try {
            const res = await this.api.deleteMerchantSignInfoApi(record.merchantNo);
            if (res.code === 200 || res.success) {
              message.success("删除成功");
              this.getTableData();
            } else {
              message.warning(res.message || res.info || "删除失败");
            }
          } catch (error) {
            console.error("删除失败:", error);
            message.error("删除失败");
          }
        },
        onCancel() {
          console.log("取消删除");
        }
      });
    },

    // 导出签名信息
    async handleExport() {
      try {
        const res = await this.api.exportMerchantSignInfoApi(this.paramsData);
        if (res.data) {
          const blob = new Blob([res.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `商户签名信息_${new Date().getTime()}.xlsx`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          message.success('导出成功');
        }
      } catch (error) {
        console.error('导出失败:', error);
        message.error('导出失败');
      }
    },

    // 分页变化
    handlePageChange(pageNo) {
      this.pagination.pageNo = pageNo;
      this.getTableData();
    },

    // 分页大小变化
    handleSizeChange(current, pageSize) {
      this.pagination.pageNo = 1;
      this.pagination.pageSize = pageSize;
      this.getTableData();
    },

    // 脱敏显示敏感数据
    maskSensitiveData(data, prefixLength = 6, suffixLength = 6) {
      if (!data) return '';
      if (data.length <= prefixLength + suffixLength) {
        return '***';
      }
      const prefix = data.substring(0, prefixLength);
      const suffix = data.substring(data.length - suffixLength);
      return `${prefix}***${suffix}`;
    },

    // 截断长文本
    maskLongText(text, maxLength = 30) {
      if (!text) return '';
      if (text.length <= maxLength) return text;
      return text.substring(0, maxLength) + '...';
    },

    // 复制到剪贴板
    copyToClipboard(text) {
      if (!text) return;

      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();

      try {
        const successful = document.execCommand('copy');
        if (successful) {
          message.success('复制成功');
        } else {
          message.error('复制失败');
        }
      } catch (err) {
        console.error('复制失败:', err);
        message.error('复制失败');
      }

      document.body.removeChild(textArea);
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ant-card-body {
  padding: 24px 34px;
}

.selectBox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 16px;

  .item {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    margin-right: 20px;

    span {
      margin-right: 8px;
      white-space: nowrap;
      min-width: 60px;
    }

    .ant-input {
      width: 150px;
    }

    .ant-select {
      min-width: 150px;
    }
  }
}

.tableBox {
  margin-bottom: 20px;

  .handleBtn {
    margin-bottom: 16px;

    .ant-btn {
      margin-right: 8px;
    }
  }
}

.pagination-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 16px;
  padding: 12px 0;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-top: none;
  border-radius: 0 0 6px 6px;
}

.sign-detail {
  max-height: 70vh;
  overflow-y: auto;
  padding: 4px;

  .detail-section {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }

    /deep/ .ant-card-head {
      min-height: 40px;
      padding: 0 12px;

      .ant-card-head-title {
        font-size: 14px;
        font-weight: 600;
        padding: 8px 0;
      }
    }

    /deep/ .ant-card-body {
      padding: 12px;
    }
  }

  .detail-value {
    font-weight: 500;
    color: #333;
  }

  .status-enabled {
    color: #52c41a;
    font-weight: 500;
  }

  .status-disabled {
    color: #ff4d4f;
    font-weight: 500;
  }

  .key-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 4px 0;

    code {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-family: 'Courier New', monospace;
      font-size: 12px;
      color: #666;
      background: #f5f5f5;
      padding: 4px 8px;
      border-radius: 4px;
    }

    .anticon-copy {
      transition: color 0.3s;

      &:hover {
        color: #096dd9;
      }
    }
  }

  .empty-state {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
  }
}

.truncate-text {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

@media (max-width: 768px) {
  .selectBox {
    .item {
      margin-right: 10px;

      .ant-input, .ant-select {
        width: 120px;
      }
    }
  }

  .sign-detail {
    .detail-section {
      /deep/ .ant-descriptions-bordered .ant-descriptions-item {
        padding: 8px 12px;
      }
    }
  }
}

/deep/ .ant-descriptions-item-label {
  font-weight: bold;
  background-color: #fafafa;
}
</style>